<template>
  <div class="wrapper box box_v">
    <div class="d-content box_f1">
        <div class="d-con">
            <div class="d-tit">
                <i class="iconfont icon-fanhui2" style="font-size: 28px;" @click="goBack"></i>
                {{title}}
            </div>
            <div class="d-tim">
                {{time}}
            </div>
            <img :src="pic" class="d-pic" alt="">
            <div class="d-context" v-html="context"></div>
            <!--附件-->
            <div v-if="filelist.length">
                <div class="black" style="margin:20px 0">附件</div>
                <div class="fjbox box" v-for="item in filelist" :key="item.id">
                    <div class="fjitem box">
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="`#${item.type}`"></use>
                        </svg>
                        <div class="content">
                            <div class="black">{{item.fileName}}</div>
                            <div class="box">
                                <div class="light-gray" style="margin-right:20px">{{item.fileSize}}</div>
                                <div class="light-gray">{{item.time}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="download pointer" @click="down(item.fileUrl,item.fileName)">下载</div>
                </div>
            </div>
            <!--附件结束-->
            <!--预约办理-->
            <div v-if="linkType==25" class="btnview">
                <Button type="primary" @click="see">去看看 ></Button>
            </div>
        </div>

    </div>
    <Spin fix v-if="loading"></Spin>
  </div>
</template>

<script>
export default {
    data() {
        return {
            title: '',
            pic: '',
            context: '',
            time: '',
            loading: false,
            linkType:0,
            filelist:[],
            id:'',
            from:'',
        }
    },
    methods: {
        down(url,name) {
            let data = {
                fileUrl:url,
                fileName:name
            }
            window.open(this.$util.concatUrl(this.urlobj.dowloadFile, data))
        },
        getDetail() {
          this.loading = true
          var url =  ''
          if (this.from == 'NewLogin') url = this.urlobj.getSysNoticeDetail(this.id)
          else url= this.urlobj.sysNoticeDetail(this.id)
            this.$get(url).then(res => {
                if(res.isSucceed){
                    let rData = res.rows[0]
                    this.title = rData.title
                    this.context = rData.context
                    this.time = rData.createTime.substring(0,10)
                    this.pic = rData.coverPicUrl
                    this.loading = false
                    this.linkType= rData.linkType
                    this.filelist = rData.fileList.map(item=>{
                        return{
                            id:item.id,
                            fileUrl:item.fileUrl,
                            fileName:item.fileName,
                            fileSize:this.$util.getFileSize(item.fileSize),
                            type:this.$util.getFileType(item.fileName),
                            time:item.createTime.split('.')[0],
                        }
                    })
                    console.log(this.filelist)
                }
            }).catch(e => {
                this.loading = false
            })
        },
        goBack() {
            this.$router.push({name: 'sysNotice'})
        },
        see(){
            this.$router.push({name: 'appointmentRecord'})
        }
    },
    mounted() {
      this.from = this.$route.query.from
        this.id =this.$route.query.id
    },
    watch:{
        $route(){
            this.id =this.$route.query.id
        },
        id(){
            this.getDetail()
        }
    },
}
</script>

<style lang="less" scoped>
.wrapper {
    height: 100%;
}
.d-content {
    height: 100%;
    background: #fff;
    width: 750px;
    margin: auto;
    position: relative;
}
.icon-fanhui2 {
    color: #999;
    position: absolute;
    left: 0;
}
.d-con {
    padding: 36px 50px 0;
}
.d-tit {
    text-align: center;
    font-size: 24px;
    color: #666;
    position: relative;
}
.d-tim {
    font-size: 16px;
    color: #999;
    text-align: center;
    margin-top: 16px;
}
.d-pic {
    text-align: center;
    width: 650px;
    height: 360px;
    margin-top: 26px;
}
.d-context {
    margin-top: 20px;
    font-size: 18px;
    color: #666;
    line-height: 1.5;
    p {
        span {
            img {
                max-width: 100%;
            }
        }
    }
}
/deep/ img {
    max-width: 100% !important;
}
.btnview{
    float:right;
    margin-top: 16px;
}
/deep/ .ivu-btn-primary{
background-color: #ff7b44;
border-color: #ff7b44
}
/*附件功能*/
.fjbox{
    margin-bottom: 20px;
    align-items: center;
}
.download{
    color:#556b93;
    font-size: 18px;
}
.fjitem{
    width: 574px;
    height: 100px;
    margin-right: 30px;
    border:1px solid #dedede;
    border-radius: 4px;
    align-items: center;
    .icon{
        font-size: 50px;
        margin:0 10px;
    }
    .content{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 50px;
    }
}
.black{
    color:#333;
    font-size: 16px;
}
.light-gray{
    color:#999;
    font-size: 13px;
}
</style>
